const statistics = [
  {
    value: "100+",
    label: "Transactions Advised"
  },
  {
    value: "50+",
    label: "Diaspora Clients Served"
  },
  {
    value: "₦5B+",
    label: "Property Value Protected"
  }
];

export const CredibilityStrip = () => {
  return (
    <section 
      className="bg-[#0A0A0B] border-y border-[#D4AF37]/20 relative overflow-hidden"
      data-testid="credibility-strip"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-8 md:py-12 lg:py-14">
        <div className="grid grid-cols-3 gap-6 md:gap-12 lg:gap-20">
          {statistics.map((stat, index) => (
            <div 
              key={index} 
              className="text-center group"
              data-testid={`stat-item-${index}`}
            >
              <div className="font-['Playfair_Display'] text-2xl md:text-4xl lg:text-5xl text-[#D4AF37] mb-1 md:mb-2">
                {stat.value}
              </div>
              <div className="text-white/60 text-xs md:text-sm tracking-wide">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
